import React, { Component } from "react";
import PropTypes from "prop-types";
import Popper from "@material-ui/core/Popper";
import Paper from "@material-ui/core/Paper";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { withStyles } from "@material-ui/core/styles";
import { Trans, withTranslation } from "react-i18next";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import FilterDiscussions from "../filter/FilterDiscussions.js";
import FilterEntries from "../filter/FilterEntries.js";
import FilterDocuments from "../filter/FilterDocuments.js";
import FilterReports from "../filter/FilterReports.js";
import FilterLists from "../filter/FilterLists.js";
import FilterRequiredReading from "../filter/FilterRequiredReading";
import FilterUserList from "../filter/FilterUserList.js";
import FilterRework from "../filter/FilterRework.js";
import FilterSearches from "../filter/FilterSearches.js";
import FilterSearchHistory from "../filter/FilterSearchHistory.js";
import FilterNotifications from "../filter/FilterNotifications.js";
import SearchFilters from "../search/SearchFilters.js";
import FilterKnowledgeItems from "../filter/FilterKnowledgeItems";
import FilterExpertQuestion from "../filter/FilterExpertQuestion";
import FilterTopics from "../../administration/components/FilterTopics";
import FilterTeams from "../../administration/components/FilterTeams";
import { withRouter } from "react-router";

const styles = (theme) => ({
  popper: {
    zIndex: 1200,
    marginTop: 7,
    maxWidth: "60%",
    '&[x-placement*="left"] $arrow': {
      top: 15,
      right: 0,
      marginLeft: "-0.9em",
      width: "1em",
      height: "3em",
      "&::before": {
        borderWidth: "1em 1em 1em 0",
        borderColor: `transparent ${
          theme.palette.common.white
        } transparent transparent`,
      },
    },
    '&[x-placement*="right"] $arrow': {
      top: 15,
      right: 0,
      marginLeft: "-0.9em",
      width: "1em",
      height: "3em",
      "&::before": {
        borderWidth: "1em 0 1em 1em",
        borderColor: `transparent transparent transparent ${
          theme.palette.common.white
        }`,
      },
    },
    '&[x-placement*="right-start"] $arrow': {
      top: 8,
      right: 0,
      marginLeft: "-0.9em",
      width: "1em",
      height: "3em",
      "&::before": {
        borderWidth: "1em 0 1em 1em",
        borderColor: `transparent transparent transparent ${
          theme.palette.common.white
        }`,
      },
    },
    '&[x-placement*="bottom"] $arrow': {
      top: 0,
      left: 0,
      marginLeft: "-0.9em",
      width: "3em",
      height: "1em",
      "&::before": {
        borderWidth: "0 1em 1em 1em",
        borderColor: `transparent transparent ${
          theme.palette.common.white
        } transparent`,
      },
    },
    '&[x-placement*="top"] $arrow': {
      left: 0,
      bottom: 0,
      marginLeft: "-0.9em",
      width: "3em",
      height: "1em",
      "&::before": {
        borderWidth: "1em 1em 0 1em",
        borderColor: `${
          theme.palette.common.white
        } transparent transparent transparent`,
      },
    },
  },
  arrow: {
    position: "absolute",
    fontSize: 7,
    width: "3em",
    height: "3em",
    "&::before": {
      content: '""',
      margin: "auto",
      display: "block",
      width: 0,
      height: 0,
      borderStyle: "solid",
    },
  },
  mobilePopper: {
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  taxonomyNodePicker: {
    margin: theme.spacing(1),
    minWidth: 200,
  },
  chipInput: {
    maxWidth: 150,
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "33.33%",
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  sortByContainer: {
    display: "flex",
    width: "100%",
  },
  sortBy: {
    // flex: 0.3,
  },
  datesContainer: {
    display: "flex",
    width: "100%",
    flexWrap: "wrap",
    "& > *": {
      margin: 5,
    },
  },
  sortByLabel: {
    marginTop: 8,
    marginRight: 10,
  },
  formControl: {
    minWidth: 182,
  },
  chipInput: {
    // margin: 5,
  },
  selectMargin: {
    marginTop: 16,
    marginLeft: 5,
    marginRight: 5,
    minWidth: 182,
  },
  userChipsWrapper: {
    display: "flex",
    flexWrap: "wrap",
  },
  filterCtr: {
    display: "flex",
    marginLeft: "auto",
    marginRight: "auto",
    overflow: "auto",
    paddingLeft: "10px",
    paddingRight: "10px",
  },
  resetButton: {
    width: "100%",
  },
  container: {
    marginLeft: "auto",
    marginRight: "auto",
    // display: "flex",
    // paddingBottom: theme.spacing(0.5),
    flexGrow: 1,
  },
});

const filterMappings = {
  FilterRework,
  FilterSearchHistory,
  FilterLists,
  FilterDocuments,
  FilterReports,
  FilterDiscussions,
  FilterEntries,
  FilterSearches,
  SearchFilters,
  FilterUserList,
  FilterRequiredReading,
  FilterNotifications,
  FilterKnowledgeItems,
  FilterExpertQuestion,
  FilterTopics,
  FilterTeams,
};

export class FilterWrapper extends Component {
  static propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      arrowRef: null,
    };
  }
  handleArrowRef = (node) => {
    this.setState({
      arrowRef: node,
    });
  };
  getFilterElement = () => {
    let WrappedElement = filterMappings[this.props.filterElement];
    return (
      <WrappedElement
        {...this.props}
        isFilterBar={this.props.isFilterBar}
        showReset={this.props.showReset}
        resetToDefaultFilters={this.props.resetToDefaultFilters}
        objectClass={this.props.objectClass}
        filter={this.props.filter}
        returnTaxonomyControl={this.props.returnTaxonomyControl}
      />
    );
  };
  render() {
    const { classes } = this.props;
    let WrappedElement = filterMappings[this.props.filterElement];
    return (
      <div className={classes.container}>
        {WrappedElement && (
          <>
            {this.props.asPopper ? (
              <Popper
                disablePortal={this.props.disablePortal}
                open={this.props.open}
                anchorEl={this.props.anchorEl}
                placement={this.props.isFilterBar ? "right-start" : "bottom"}
                className={this.props.isMobile === true ? classes.mobilePopper : classes.popper}
                modifiers={{
                  flip: {
                    enabled: true,
                  },
                  arrow: {
                    enabled: true,
                    element: this.state.arrowRef,
                  },
                  preventOverflow: {
                    enabled: !this.props.isFilterBar,
                    escapeWithReference: this.props.isFilterBar,
                  },
                }}
              >
                <span className={classes.arrow} ref={this.handleArrowRef} />
                <Paper className={classes.paper} elevation={10}>
                  <DialogTitle>
                    {this.props.title}
                    <IconButton
                      aria-label="Close"
                      autoFocus
                      className={classes.closeButton}
                      onClick={this.props.onClose}
                    >
                      <CloseIcon />
                    </IconButton>
                  </DialogTitle>
                  <DialogContent>{this.getFilterElement()}</DialogContent>
                </Paper>
              </Popper>
            ) : (
              this.getFilterElement()
            )}
          </>
        )}
      </div>
    );
  }
}
export default withStyles(styles)(withTranslation()(withRouter(FilterWrapper)));
